<script>
  import { cn } from '@lib/utils'

  let { message = "No results found", class: className } = $props()

  let baseClass = "col-span-full bg-stone-50 border border-dashed border-stone-200 flex items-center justify-center h-[600px] text-stone-500 text-sm rounded-md"
  let classes = $derived(cn(baseClass, className))
</script>


<div class={classes}>
  {message}
</div>